import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {DatasetAwareComponent} from "../dataset-aware.component";

const DEFAULT_CLS = 'app-radioset list-group inline';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-radioset',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmRadioset]',
  template: `<ng-template [ngIf]="!groupby" [ngIfElse]="groupedListTemplate">
    <li [ngClass]="['radio', 'app-radio',itemclass,itemsPerRowClass]"
        [class.active]="item.selected"
        *ngFor="let item of datasetItems;let i = index"
        partialContainer
        >
      <!-- Default item template -->
      <label *ngIf="!content" class="app-radioset-label"
             [ngClass]="{'disabled':disabled || readonly}"
             [title]="item.label">
        <input [name]="'radioset_'+widgetId" type="radio" [attr.aria-checked]="item.selected" [attr.data-attr-index]="i"
               [value]="item.key" [disabled]="disabled || readonly" [tabindex]="tabindex" [checked]="item.selected"
               [attr.aria-label]="item.key"/>
        <span class="caption" [textContent]="item.label"></span>
      </label>
      <!-- Custom partial template -->
      <label *ngIf="content" class="app-radioset-label"
             [ngClass]="{'disabled':disabled || readonly}"
             [title]="item.label">
        <input [name]="'radioset_'+widgetId" type="radio" [attr.aria-checked]="item.selected" [attr.data-attr-index]="i"
               [value]="item.key" [disabled]="disabled || readonly" [tabindex]="tabindex" [checked]="item.selected"
               [attr.aria-label]="item.key"/>
        <span class="caption customTemplate" partial-container-target></span>
      </label>
    </li>
  </ng-template>
  <ng-template #groupedListTemplate>
    <li *ngFor="let groupObj of groupedData" class="app-list-item-group">
      <ul class="item-group">
        <li class="list-group-header" [title]="groupObj.key" [ngClass]="{'collapsible-content': collapsible}">
          <h4 class="group-title">{{groupObj.key}}
            <div class="header-action">
              <i class="app-icon wi action wi-chevron-up" *ngIf="collapsible" title="{{appLocale.LABEL_COLLAPSE}}/{{appLocale.LABEL_EXPAND}}"></i>
              <span *ngIf="showcount" class="label label-default" [textContent]="groupObj.data.length"></span>
            </div>
          </h4>
        </li>
        <li *ngFor="let item of groupObj.data; let i = index;"
            [ngClass]="['radio', 'app-radio', 'group-list-item', itemclass, itemsPerRowClass]"
            [class.active]="item.selected"
            partialContainer
            >
          <!-- Default item template -->
          <label *ngIf="!content" class="app-radioset-label"
                 [ngClass]="{'disabled':disabled || readonly}"
                 [title]="item.label">
            <input [name]="'radioset_' + widgetId" type="radio" [attr.aria-checked]="item.selected" [attr.data-attr-index]="i"
                   [value]="item.key" [disabled]="disabled || readonly" [tabindex]="tabindex" [checked]="item.selected"/>
            <span class="caption" [textContent]="item.label"></span>
          </label>
          <!-- Custom partial template -->
          <label *ngIf="content" class="app-radioset-label"
                 [ngClass]="{'disabled':disabled || readonly}"
                 [title]="item.label">
            <input [name]="'radioset_' + widgetId" type="radio" [attr.aria-checked]="item.selected" [attr.data-attr-index]="i"
                   [value]="item.key" [disabled]="disabled || readonly" [tabindex]="tabindex" [checked]="item.selected"/>
            <span class="caption customTemplate" partial-container-target></span>
          </label>
        </li>
      </ul>
    </li>
  </ng-template>
  `,
  providers: [
    provideAsWidgetRef(RadiosetComponent)
  ],
  exportAs: 'wmRadioset',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class RadiosetComponent extends DatasetAwareComponent {
  static initializeProps = register('wm-radioset');

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }
}

